import { apiContractRequest } from "./client";

export const ownerFinanceStatsApi = {
  history({ start = "", end = "", currency = "", accountId = "", category = "", bucket = "month" } = {}) {
    return apiContractRequest("/api/owner/finance/stats/history", {
      params: {
        ...(start ? { start } : {}),
        ...(end ? { end } : {}),
        ...(currency ? { currency } : {}),
        ...(accountId ? { accountId } : {}),
        ...(category ? { category } : {}),
        bucket,
      },
    });
  },
  future({ month = "", currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/finance/stats/future", { params: { month, currency, tzOffsetMinutes } });
  },
  updateFutureTarget(payload = {}) {
    return apiContractRequest("/api/owner/finance/stats/future/target", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: payload,
    });
  },
  accounts() {
    return apiContractRequest("/api/owner/finance/accounts", { params: { includeArchived: true } });
  },
};
